import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getDashboardFilter } from "app/utils/utils";
import { toast } from "react-toastify";
import axiosApiInstance from "app/services/axios";
import {
  getDataEndPoint,
  loggedInUserDetailsEndPoint,
  switchUserEndPoint,
  updateDataEndPoint,
  getEntityHistoryApiUrl,
} from "app/utils/constants/paths";
import { DATASOURCE_CONFIG } from "app/config";
const tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;

const initialState = {
  openSwitchAccountModal: false,
  openSwitchUserModal: false,
  globalAccount: "",
  dashboardDateFilter: getDashboardFilter("day"),
  globalListFlag: false,
  globalAccountsList: [],
  globalAdvAccountsList: [],
  globalPubAccountsList: [],
  globalCompaniesList: [],
  globalPublishersList: [],
  globalAdvertisersList: [],
  globalContentTypesList: [],
  globalUsersList: [],
  isAdvertisersLoaded: false,
  countriesList: [],
  authUserData: {},
  globalThemesList: [],
  authUserTheme: {},
  globalCampaignsList: [],
  globalBannersList: [],
  searchLoading: false,
  globalFilterAccountsList: [],
  globalFilterAdvertisersList: [],
  globalFilterCampaignsList: [],
  globalFilterBannersList: [],

  authUserLogo: "",
  authUserLogoHeight:'',
  dmaStateCityList: [],
  userTimezone: "",
  openUserTimezoneModal: false,
  prepaidAccountDetails: {
    hasPrepaidAccounts: false,
    balance: 0,
    hasSinglePrepaidAcc: false,
    prepaidAccountsCount: 0,
    prepaidAccounts: [],
  },
  historyLoader: false,
  globalBiddersList: [],
  globalCustomDspParameter: [],
  globalPrivateAccountsList: [],
  globalPackagesList: [],
};
// const getAccountName = (accountList, account) => {
//   let obj = accountList.find((o) => o.value == account);
//   return obj.label;
// };

const Common = createSlice({
  name: "common",
  initialState,
  reducers: {
    updateAuthUserTheme(state, action) {
      state.authUserTheme = action.payload;
    },
    updateAuthUserLogo(state, action) {
      state.authUserLogo = action.payload;
    },
    updateAuthUserLogoHeight(state, action) {
      state.authUserLogoHeight = action.payload;
    },
    showHideSwitchAccountModal(state, action) {
      state.openSwitchAccountModal = action.payload;
    },
    showHideSwitchUserModal(state, action) {
      state.openSwitchUserModal = action.payload;
    },
    switchToAccount(state, action) {
      state.globalAccount = action.payload.value;
      state.openSwitchAccountModal = false;
      //customToast("info", "Hello");
      //toast.success("Now viewing '" + action.payload.label + "'");
    },
    updateDashboardFilter(state, action) {
      state.dashboardDateFilter = getDashboardFilter(action.payload);
    },
    updateDashboardFilterDates(state, action) {
      state.dashboardDateFilter = action.payload;
    },
    updateGlobalListFlag(state, action) {
      state.globalListFlag = action.payload.globalListFlag;
    },
    updateAllGlobalList(state, action) {
      let pageaction = action.payload.action;
      let page = action.payload.page;
      let switchUserList = state.authUserData?.switch_users_list;
      let status = action.payload?.status;
      if (page == "company") {
        let companyList = state.globalCompaniesList;
        if (pageaction == "add") {
          let details = action.payload.details;
          companyList.push(action.payload.details);
        } else if (pageaction == "delete") {
          companyList = companyList.filter(
            (item) => item.value !== action.payload.id
          );
        } else {
          companyList = companyList.filter(
            (item) => item.value !== action.payload.id
          );
          companyList.push(action.payload.details);
        }
        state.globalCompaniesList = companyList;
      } else if (page == "account") {
        let accountList = state.globalAccountsList;

        if (pageaction == "add") {
          accountList.push(action.payload.details);
        } else if (pageaction == "delete") {
          // if (status == "1") {
          //   accountList.push(action.payload.details);
          // } else {
          //   accountList = accountList.filter(
          //     (item) => item.value !== action.payload.id
          //   );
          // }
          accountList = accountList.filter(
            (item) => item.value !== action.payload.id
          );
        } else {
          accountList = accountList.filter(
            (item) => item.value !== action.payload.id
          );
          accountList.push(action.payload.details);
        }
        state.globalAccountsList = accountList;
      } else if (page == "advertiser") {
        let advertiserList = state.globalAdvertisersList;
        if (pageaction == "add") {
          advertiserList.push(action.payload.details);
        } else if (pageaction == "delete") {
          // if (status == "1") {
          //   advertiserList.push(action.payload.details);
          // } else {
          //   advertiserList = advertiserList.filter(
          //     (item) => item.value !== action.payload.id
          //   );
          // }
          advertiserList = advertiserList.filter(
            (item) => item.value !== action.payload.id
          );
        } else {
          let details = action.payload.details;
          advertiserList.map((info) => {
            if (info.value == details.value) {
              info.label = details.label;
              info.account_id = details.account_id;
            }
          });
        }
        state.globalAdvertisersList = advertiserList;
      } else if (page == "user") {
        let userList = state.globalUsersList;
        let details = action.payload.details;
        let switchDetails = {
          id: details.value,
          name: details.label,
          username: details.username,
          reference_user_id: state.authUserData?.user_id,
        };
        if (pageaction == "add") {
          userList.push(action.payload.details);
          switchUserList.push(switchDetails);
        } else if (pageaction == "delete") {
          userList = userList.filter(
            (item) => item.value !== action.payload.id
          );
          switchUserList = switchUserList.filter(
            (item) => item.id !== action.payload.id
          );
        } else {
          userList = userList.filter(
            (item) => item.value !== action.payload.id
          );

          userList.push(action.payload.details);
          switchUserList = switchUserList.filter(
            (item) => item.id !== action.payload.id
          );
          switchUserList.push(switchDetails);
        }
        state.globalUsersList = userList;
        state.authUserData["switch_users_list"] = switchUserList;
      } else if (page == "publisher") {
        let pubList = state.globalPublishersList;
        if (pageaction == "add") {
          pubList.push(action.payload.details);
        } else if (pageaction == "delete") {
          // if (status == "1") {
          //   console.log('ffgfg')
          //   pubList.push(action.payload.details);
          // } else {
          //   pubList = pubList.filter((item) => item.value !== action.payload.id);
          // }
          pubList = pubList.filter((item) => item.value !== action.payload.id);
        } else {
          pubList = pubList.filter((item) => item.value !== action.payload.id);
          pubList.push(action.payload.details);
        }
        state.globalPublishersList = pubList;
      } else if (page == "theme") {
        let themeList = state.globalThemesList;
        if (pageaction == "add") {
          themeList.push(action.payload.details);
        } else if (pageaction == "delete") {
          themeList = themeList.filter(
            (item) => item.value !== action.payload.id
          );
        } else {
          themeList = themeList.filter(
            (item) => item.value !== action.payload.id
          );
          themeList.push(action.payload.details);
        }
        state.globalThemesList = themeList;
      } else if (page == "campaign") {
        let campList = state.globalCampaignsList;
        if (pageaction == "add") {
          campList.push(action.payload.details);
        } else if (pageaction == "delete") {
          campList = campList.filter(
            (item) => item.value !== action.payload.id
          );
        } else {
          let details = action.payload.details;
          campList.map((info) => {
            if (info.value == details.value) {
              info.label = details.label;
            }
            return info;
          });
        }
        state.globalCampaignsList = campList;
      } else if (page == "bidder") {
        let bidderList = state.globalBiddersList;
        if (pageaction == "add") {
          bidderList.push(action.payload.details);
        } else if (pageaction == "update") {
          bidderList = bidderList.filter(
            (item) => item.id !== action.payload.id
          );
          bidderList.push(action.payload.details);
        }
        state.globalBiddersList = bidderList;
      }
    },
    showHideUserTimezoneModal(state, action) {
      state.openUserTimezoneModal = action.payload;
    },
    updateUserTimezone(state, action) {
      state.userTimezone = action.payload;
    },
    updateAuthUserTimeZone(state, action) {
      state.authUserData.report_timezone_country = action.payload;
    },
  },

  extraReducers(builder) {
    builder
      .addCase(GetAllPreloadDataListThunk.pending, (state) => {
        state.globalListFlag = false;
      })
      .addCase(GetAllPreloadDataListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results.length > 0) {
          state.globalCompaniesList = action.payload.data.results[0];
          state.globalAccountsList = action.payload.data.results[1];
          state.globalPublishersList = action.payload.data.results[2];
          state.globalAdvertisersList = action.payload.data.results[3];
          state.globalContentTypesList = action.payload.data.results[4];
          state.globalUsersList = action.payload.data.results[5];
          let Countriesdata = action.payload.data.results[6];
          let rowtData = { name: "ROTW", id: "ROTW" };
          Countriesdata.push(rowtData);
          state.countriesList = Countriesdata;

          state.globalThemesList = action.payload.data.results[7];
          state.dmaStateCityList = action.payload.data.results[8];
          state.globalCampaignsList = action.payload.data.results[9];
          state.globalBannersList = action.payload.data.results[10];
          state.globalBiddersList = action.payload.data.results[11];
          state.globalPrivateAccountsList = action.payload.data.results[13];
          state.globalPackagesList = action.payload.data.results[14];
          let openrtb = [
            {
              value: "0",
              label: "Open RTB",
              handler: "openrtb",
              method: "POST",
              g_m_s: [],
              i_m_s: [],
              c_m_s: [],
            },
          ];
          let customresultData = action.payload.data.results[12];

          let finalCustomDspList = customresultData.map((info) => {
            info.g_m_s =
              info.g_m_s != "" && info.g_m_s != null
                ? JSON.parse(info.g_m_s)
                : [];
            info.i_m_s =
              info.i_m_s != "" && info.i_m_s != null
                ? JSON.parse(info.i_m_s)
                : [];
            info.c_m_s =
              info.c_m_s != "" && info.c_m_s != null
                ? JSON.parse(info.c_m_s)
                : [];
            return info;
          });
          state.globalCustomDspParameter = [...openrtb, ...finalCustomDspList];
        }
        if (action.payload.data.status === 1) {
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        if (state.globalAccountsList.length > 0) {
          state.globalAccount = state.globalAccountsList[0].value;
        }
        state.globalListFlag = true;
      })
      .addCase(GetAllPreloadDataListThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
      })
      .addCase(getPrepaidAccountDetails.pending, (state) => {
        state.globalListFlag = false;
      })
      .addCase(getPrepaidAccountDetails.fulfilled, (state, action) => {
        if (action.payload.data?.results.length > 0) {
          let prePaidAccountData = action.payload.data?.results[0];
          let totalSpent = 0;
          let totalReceived = 0;
          let totalBalance = 0;
          let prepaidAccounts = [];
          for (let i = 0; i < prePaidAccountData.length; i++) {
            let prepaidInfo = prePaidAccountData[i];
            let spent = parseFloat(prepaidInfo.total_spent);
            let total_received = parseFloat(prepaidInfo.total_received);
            spent = isNaN(spent) ? 0 : spent;
            total_received = isNaN(total_received) ? 0 : total_received;
            if (!isNaN(spent)) {
              totalSpent += spent;
            }
            if (!isNaN(total_received)) {
              totalReceived += total_received;
            }
            prepaidAccounts.push({
              id: prepaidInfo.id,
              name: prepaidInfo.name,
              company: prepaidInfo.company,
              total_spent: spent,
              total_received,
              balance: total_received - spent,
            });
          }
          totalBalance = totalReceived - totalSpent;
          let prepaidAccInfo = {
            hasPrepaidAccounts: prePaidAccountData.length > 0 ? true : false,
            balance: totalBalance,
            hasSinglePrepaidAcc: prePaidAccountData.length == 1 ? true : false,
            prepaidAccountsCount: prePaidAccountData.length,
            prepaidAccounts,
          };
          state.prepaidAccountDetails = prepaidAccInfo;
        }

        state.globalListFlag = true;
      })
      .addCase(getPrepaidAccountDetails.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
      })
      .addCase(getLoggedInUserDetails.pending, (state) => {
        state.globalListFlag = false;
      })
      .addCase(getLoggedInUserDetails.fulfilled, (state, action) => {
        if (action.payload.data?.success == true) {
          state.authUserData = action.payload.data?.user_data;
          state.userTimezone =
            action.payload.data?.user_data?.report_timezone_country;
        }
        //state.globalListFlag = true;
      })
      .addCase(getLoggedInUserDetails.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
      })
      .addCase(switchUser.pending, (state) => {
        state.globalListFlag = false;
      })
      .addCase(switchUser.fulfilled, (state, action) => {
        if (action.payload.data?.success == true) {
          const resultData = action.payload.data;
          localStorage.setItem("access_token", resultData.access_token);
          localStorage.setItem("refresh_token", resultData.refresh_token);
        }
        //state.globalListFlag = true;
      })
      .addCase(switchUser.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
      })
      .addCase(getGlobalCampaignsListThunk.pending, (state) => {
        state.searchLoading = true;
      })
      .addCase(getGlobalCampaignsListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results.flat(1);
          state.globalFilterCampaignsList = data;
        }
        state.searchLoading = false;
      })
      .addCase(getGlobalCampaignsListThunk.rejected, (state, action) => {})
      .addCase(getGlobalBannersListThunk.pending, (state) => {
        state.searchLoading = true;
      })
      .addCase(getGlobalBannersListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results.flat(1);
          state.globalFilterBannersList = data;
        }
        state.searchLoading = false;
      })
      .addCase(getGlobalBannersListThunk.rejected, (state, action) => {})
      .addCase(GetGlobalAccountsFilterList.pending, (state) => {
        state.searchLoading = true;
      })
      .addCase(GetGlobalAccountsFilterList.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results.flat(1);
          state.globalFilterAccountsList = data;
        }
        state.searchLoading = false;
      })
      .addCase(GetGlobalAccountsFilterList.rejected, (state, action) => {})

      .addCase(GetGlobalAdvertisersFilterList.pending, (state) => {
        state.searchLoading = true;
      })
      .addCase(GetGlobalAdvertisersFilterList.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results.flat(1);
          state.globalFilterAdvertisersList = data;
        }
        state.searchLoading = false;
      })
      .addCase(GetGlobalAdvertisersFilterList.rejected, (state, action) => {})

      .addCase(switchUserTimezone.pending, (state) => {})
      .addCase(switchUserTimezone.fulfilled, (state, action) => {})
      .addCase(switchUserTimezone.rejected, (state, action) => {})
      .addCase(GetEntiryHistoryListThunk.pending, (state) => {
        state.historyLoader = true;
      })
      .addCase(GetEntiryHistoryListThunk.fulfilled, (state, action) => {
        state.historyLoader = false;
      })
      .addCase(GetEntiryHistoryListThunk.rejected, (state, action) => {});
  },
});
export const getPrepaidAccountDetails = createAsyncThunk(
  "common/getPrepaidAccountDetails",
  async (payload) => {
    const accountsArr = payload.accounts;

    let Qry =
      "select id,name,company,prepaid_gross as total_spent,(select sum(payment) from accounts_finance where accountid=accounts.id) as total_received from " +
      tablePrefix +
      "accounts where is_prepaid=1 and id IN('" +
      accountsArr.join("','") +
      "') order by company asc,name asc";

    const queryBody = {
      queries: [
        {
          query: Qry,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetAllPreloadDataListThunk = createAsyncThunk(
  "common/GetAllPreloadDataListThunk",
  async (payload) => {
    const is_sys_admin = payload.user_data.is_sys_admin;
    console.log("login Users Data:", payload.user_data);
    let companiesQry =
      "select id as value,name as label,email,theme,logo_url,logo_height from " +
      tablePrefix +
      "companies where status ='1' order by name asc";
    /* let accountsQry =
      "select id as value,CONCAT(company,' [',NAME,']') as label,name as name,email,company,company_id,theme from " +
      tablePrefix +
      "accounts order by name asc";*/
    let accountsQry =
      "select id as value,CONCAT(company, ' [', NAME, ']',CASE WHEN is_prepaid =1 THEN '[PREPAID]' ELSE  ' ' END) as label,name as name,email,company,company_id,theme,is_prepaid,is_seat_on_platform as seatType,bidder_endpoints_limit,story_cost_value,audience_providers,audience_targeting,logo_url,pixel_domain,conv_1_label,conv_2_label,conv_3_label,conv_4_label,rev_share,hide_report_metrics from " +
      tablePrefix +
      "accounts order by name asc";

    let packagesQry =
      "select id as value,name as label,accountid from " +
      tablePrefix +
      "campaign_packages order by name asc";

    let pubsQry =
      "select id as value,name as label,accountid as account_id,pub_code from " +
      tablePrefix +
      "publishers where active='1' order by name asc";
    let advsQry =
      "select id as value,name as label,accountid as account_id from " +
      tablePrefix +
      "advertisers where active ='1' order by name asc";

    let themesQry =
      "select id as value,name as label,header_options,sidebar_options,maincontent_options,footer_options from " +
      tablePrefix +
      "themes where status='1' order by name asc";

    let campaignsQuery =
      "select id as value,name as label,advertiserid,accountid,package from " +
      tablePrefix +
      "campaigns where status!='2' and (expire_time >= " +
      DATASOURCE_CONFIG.CURRENT_DATE +
      "" +
      DATASOURCE_CONFIG.CAMPAIGN_UNDEFINE_TIME +
      " OR expire_time is null OR  expire_time > " +
      DATASOURCE_CONFIG.CURRENT_DATE +
      " - " +
      DATASOURCE_CONFIG.CAMPAIGN_EXPIRY_INTERVAL +
      ") order by name asc";
    let campaign_undefine_time = "";
    if (DATASOURCE_CONFIG.DATASOURCE == "mysql") {
      campaign_undefine_time = " OR c.expire_time='0000-00-00 00:00:00'  ";
    }
    console.log("dfdf", campaign_undefine_time);
    let bannersQuery =
      "select b.id as value,b.name as label,b.campaignid from " +
      tablePrefix +
      "banners as b," +
      tablePrefix +
      "campaigns as c  where c.status !='2'  and b.campaignid=c.id  and (c.expire_time >= " +
      DATASOURCE_CONFIG.CURRENT_DATE +
      "  OR c.expire_time is null OR   c.expire_time > " +
      DATASOURCE_CONFIG.CURRENT_DATE +
      " - " +
      DATASOURCE_CONFIG.CAMPAIGN_EXPIRY_INTERVAL +
      " " +
      campaign_undefine_time +
      ") order by b.name asc";

    // Organization Query
    if (is_sys_admin != 1) {
      let authCompany = payload.user_data?.user_assoc_companies
        ? payload.user_data?.user_assoc_companies
        : [];
      if (authCompany.length > 0) {
        companiesQry =
          "select id as value,name as label,email,theme,logo_url,logo_height from " +
          tablePrefix +
          "companies where status ='1' and id IN ('" +
          authCompany.join("','") +
          "') order by name asc";
      } else {
        companiesQry =
          "select id as value,name as label,email,theme,logo_url,logo_height from " +
          tablePrefix +
          "companies where status ='1' and id IN (0) order by name asc";
      }
    }

    if (is_sys_admin != 1) {
      let authAdvAccounts = payload.user_data?.user_assoc_accounts?.advertiser
        ? payload.user_data?.user_assoc_accounts?.advertiser
        : [];
      let authPubAccounts = payload.user_data?.user_assoc_accounts?.publisher
        ? payload.user_data?.user_assoc_accounts?.publisher
        : [];

      let authBidderAccounts = payload.user_data?.user_assoc_accounts?.bidder
        ? payload.user_data?.user_assoc_accounts?.bidder
        : [];

      if (
        authAdvAccounts.length > 0 ||
        authPubAccounts.length > 0 ||
        authBidderAccounts.length > 0
      ) {
        let authAccounts = [
          ...authAdvAccounts,
          ...authPubAccounts,
          ...authBidderAccounts,
        ];
        var acntString = "'" + authAccounts.join("','") + "'";
      }
      accountsQry =
        "select id as value,CONCAT(company, ' [', NAME, ']',CASE WHEN is_prepaid =1 THEN '[PREPAID]' ELSE  ' ' END) as label,name as name,email,company,company_id,theme,is_prepaid,is_seat_on_platform as seatType,bidder_endpoints_limit,story_cost_value,audience_providers,audience_targeting,logo_url,pixel_domain,conv_1_label,conv_2_label,conv_3_label,conv_4_label,rev_share,hide_report_metrics from " +
        tablePrefix +
        "accounts where id IN(" +
        acntString +
        ") order by name asc";

      packagesQry =
        "select id as value,name as label,accountid from " +
        tablePrefix +
        "campaign_packages  where accountid IN('-1'," +
        acntString +
        ") order by name asc";

      //Advertisers Query
      let authAdvs = payload.user_data?.user_assoc_advertisers
        ? payload.user_data?.user_assoc_advertisers
        : [];
      if (authAdvs.length > 0) {
        var advString = "'" + authAdvs.join("','") + "'";
        advsQry =
          "select id as value,name as label,accountid as account_id from " +
          tablePrefix +
          "advertisers where id IN(" +
          advString +
          ")  and active ='1' order by name asc";

        campaignsQuery =
          "select id as value,name as label,advertiserid,accountid,package from " +
          tablePrefix +
          "campaigns where status!='2' and advertiserid IN(" +
          advString +
          ") and (expire_time >= " +
          DATASOURCE_CONFIG.CURRENT_DATE +
          " OR expire_time is null " +
          DATASOURCE_CONFIG.CAMPAIGN_UNDEFINE_TIME +
          " OR expire_time > " +
          DATASOURCE_CONFIG.CURRENT_DATE +
          " - " +
          DATASOURCE_CONFIG.CAMPAIGN_EXPIRY_INTERVAL +
          ") order by name asc";
        bannersQuery =
          "select b.id as value,b.name as label,b.campaignid from " +
          tablePrefix +
          "banners as b," +
          tablePrefix +
          "campaigns as c  where c.status !='2' and c.advertiserid IN(" +
          advString +
          ") and b.campaignid=c.id and (c.expire_time >= " +
          DATASOURCE_CONFIG.CURRENT_DATE +
          " OR c.expire_time is null " +
          campaign_undefine_time +
          " OR  c.expire_time > " +
          DATASOURCE_CONFIG.CURRENT_DATE +
          " - " +
          DATASOURCE_CONFIG.CAMPAIGN_EXPIRY_INTERVAL +
          ") order by b.name asc";
      } else {
        advsQry =
          "select id as value,name as label,accountid as account_id from " +
          tablePrefix +
          "advertisers where id IN('0') and active ='1' order by name asc";
        campaignsQuery =
          "select id as value,name as label,advertiserid,accountid,package from " +
          tablePrefix +
          "campaigns where status!='2' and advertiserid IN('0') and (expire_time >= " +
          DATASOURCE_CONFIG.CURRENT_DATE +
          " OR expire_time is null " +
          DATASOURCE_CONFIG.CAMPAIGN_UNDEFINE_TIME +
          " OR expire_time > " +
          DATASOURCE_CONFIG.CURRENT_DATE +
          " - " +
          DATASOURCE_CONFIG.CAMPAIGN_EXPIRY_INTERVAL +
          ") order by name asc";
        bannersQuery =
          "select b.id as value,b.name as label,b.campaignid from " +
          tablePrefix +
          "banners as b," +
          tablePrefix +
          "campaigns as c  where c.status!='2' and c.advertiserid IN('0') and b.campaignid=c.id and (c.expire_time >= " +
          DATASOURCE_CONFIG.CURRENT_DATE +
          " OR c.expire_time is null " +
          campaign_undefine_time +
          " OR c.expire_time > " +
          DATASOURCE_CONFIG.CURRENT_DATE +
          " - " +
          DATASOURCE_CONFIG.CAMPAIGN_EXPIRY_INTERVAL +
          ") order by b.name asc";
      }

      //Pubs Query
      let authPubs = payload.user_data?.user_assoc_publishers
        ? payload.user_data?.user_assoc_publishers
        : [];
      if (authPubs.length > 0) {
        var pubsString = "'" + authPubs.join("','") + "'";
        pubsQry =
          "select id as value,name as label,accountid as account_id,pub_code from " +
          tablePrefix +
          "publishers where id IN(" +
          pubsString +
          ")  and active='1' order by name asc";
      } else {
        pubsQry =
          "select id as value,name as label,accountid as account_id,pub_code from " +
          tablePrefix +
          "publishers where id IN('0') and active='1' order by name asc;";
      }
    }

    let biddersQuery =
      "select id as value,name as label,id,name,imp_type,accountid from " +
      tablePrefix +
      "bidders where active='1' order by name asc";
    if (is_sys_admin != "1") {
      let authBidderAccounts = payload.user_data?.user_assoc_accounts?.bidder
        ? payload.user_data?.user_assoc_accounts?.bidder
        : [];
      if (authBidderAccounts.length > 0) {
        let authAccounts = authBidderAccounts;
        var acntString = "'" + authAccounts.join("','") + "'";
        biddersQuery =
          "select id as value,name as label,id,name,imp_type,accountid from " +
          tablePrefix +
          " bidders where accountid in (" +
          acntString +
          ") ";
      } else {
        biddersQuery =
          "select id as value,name as label,id,name,imp_type,accountid from " +
          tablePrefix +
          "bidders where id IN('0') and active='1' order by name asc;";
      }
    }

    const queryBody = {
      queries: [
        {
          query: companiesQry,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query: accountsQry,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query: pubsQry,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query: advsQry,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query:
            "select code as value,name from " + tablePrefix + "content_types;",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query:
            "select id as value,name as label,username,email as account_id from " +
            tablePrefix +
            "users where is_active='1'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query:
            "select name,iso3 as id,iso2,latitude as lat,longitude as lng from " +
            tablePrefix +
            "countries",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },

        {
          query: themesQry,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query:
            "select dma_code,dma_code as id, concat(dma_name,' (DMA)') as name,0 as lat,0 as lng,'dma' as type from " +
            tablePrefix +
            "geodma",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query: campaignsQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query: bannersQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query: biddersQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query:
            "Select id as value,custom_handler as handler,name as label,method,global_mapping_structure as g_m_s,inv_mapping_structure as i_m_s,inv_category_mapping as c_m_s,auction_type from " +
            tablePrefix +
            "custom_dsps_info ",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query:
            "select id as value,CONCAT(company, ' [', NAME, ']',CASE WHEN is_prepaid =1 THEN '[PREPAID]' ELSE  ' ' END) as label,name as name,email,company,company_id,theme,is_prepaid,is_seat_on_platform as seatType,bidder_endpoints_limit,story_cost_value,audience_providers,audience_targeting,logo_url,pixel_domain,conv_1_label,conv_2_label,conv_3_label,conv_4_label,rev_share from " +
            tablePrefix +
            "accounts where is_seat_on_platform='2' order by name asc",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query: packagesQry,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const getLoggedInUserDetails = createAsyncThunk(
  "common/getLoggedInUserDetails",
  async (payload) => {
    try {
      const response = await axiosApiInstance.post(loggedInUserDetailsEndPoint);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const switchUser = createAsyncThunk(
  "common/switchUser",
  async (payload) => {
    try {
      const response = await axiosApiInstance.post(switchUserEndPoint, payload);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const switchUserTimezone = createAsyncThunk(
  "common/switchUserTimezone",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "update " +
            tablePrefix +
            "users set report_timezone_country='" +
            payload.timezone +
            "' where id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetGlobalAccountsFilterList = createAsyncThunk(
  "common/GetGlobalAccountsFilterList",
  async (payload) => {
    try {
      let condition = [];
      if (payload.accounts.length > 0) {
        let accountsStr = "'" + payload.accounts.join("','") + "'";
        condition.push("id IN (" + accountsStr + ")");
      }
      condition.push(
        "name " + DATASOURCE_CONFIG.QUERY_LIKE + " '%" + payload.search + "%'"
      );
      condition.push("active ='1'");
      let where = "";
      if (condition.length > 0) {
        where = " where " + condition.join(" and ") + "";
      }

      const queryBody = {
        queries: [
          {
            query:
              "select id as value,name as label from " +
              tablePrefix +
              "accounts " +
              where +
              " limit 10",
            datasource: DATASOURCE_CONFIG.DATASOURCE,
          },
        ],
      };
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetGlobalAdvertisersFilterList = createAsyncThunk(
  "common/GetGlobalAdvertisersFilterList",
  async (payload) => {
    try {
      let condition = [];
      if (payload.accounts.length > 0) {
        let accountsStr = "'" + payload.accounts.join("','") + "'";
        condition.push("accountid IN (" + accountsStr + ")");
      }
      if (payload.advertisers.length > 0) {
        let advertisersStr = "'" + payload.advertisers.join("','") + "'";
        condition.push("id IN (" + advertisersStr + ")");
      }
      condition.push(
        "name " + DATASOURCE_CONFIG.QUERY_LIKE + " '%" + payload.search + "%'"
      );
      condition.push("active ='1'");
      let where = "";
      if (condition.length > 0) {
        where = " where " + condition.join(" and ") + "";
      }

      const queryBody = {
        queries: [
          {
            query:
              "select id as value,name as label,accountid from " +
              tablePrefix +
              "advertisers " +
              where +
              " limit 10",
            datasource: DATASOURCE_CONFIG.DATASOURCE,
          },
        ],
      };
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const getGlobalCampaignsListThunk = createAsyncThunk(
  "common/getGlobalCampaignsListThunk",
  async (payload) => {
    try {
      let condition = [];

      if (payload.accounts.length > 0) {
        let accountsStr = "'" + payload.accounts.join("','") + "'";
        condition.push("accountid IN (" + accountsStr + ")");
      }
      if (payload.advertisers.length > 0) {
        let advertisersStr = "'" + payload.advertisers.join("','") + "'";
        condition.push("advertiserid IN (" + advertisersStr + ")");
      }
      condition.push(
        "name " + DATASOURCE_CONFIG.QUERY_LIKE + " '%" + payload.search + "%'"
      );
      condition.push("status !='2'");
      let where = "";
      if (condition.length > 0) {
        where = " where " + condition.join(" and ") + "";
      }

      const queryBody = {
        queries: [
          {
            query:
              "select id as value,name as label,advertiserid from " +
              tablePrefix +
              "campaigns " +
              where +
              " limit 30",
            datasource: DATASOURCE_CONFIG.DATASOURCE,
          },
        ],
      };

      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const getGlobalBannersListThunk = createAsyncThunk(
  "common/getGlobalBannersListThunk",
  async (payload) => {
    try {
      let condition = [];
      let campaignsTable = "";

      if (payload.accounts.length > 0 || payload.advertisers.length > 0) {
        campaignsTable = "," + tablePrefix + "campaigns as c ";
        if (payload.accounts.length > 0) {
          let accountsStr = "'" + payload.accounts.join("','") + "'";
          condition.push("c.accountid IN (" + accountsStr + ")");
        }
        if (payload.advertisers.length > 0) {
          let advertisersStr = "'" + payload.advertisers.join("','") + "'";
          condition.push("c.advertiserid IN (" + advertisersStr + ")");
        }
        condition.push("c.id = b.campaignid");
        condition.push("c.status !='2'");
      }

      if (payload.campaigns.length > 0) {
        let campaignsStr = "'" + payload.campaigns.join("','") + "'";
        condition.push("b.campaignid IN (" + campaignsStr + ")");
      }
      condition.push(
        "b.name " + DATASOURCE_CONFIG.QUERY_LIKE + " '%" + payload.search + "%'"
      );
      condition.push("b.status !='2'");
      let where = "";
      if (condition.length > 0) {
        where = " where " + condition.join(" and ") + "";
      }

      const queryBody = {
        queries: [
          {
            query:
              "select b.id as value,b.name as label,b.campaignid from " +
              tablePrefix +
              "banners as b " +
              campaignsTable +
              where +
              " limit 30",
            datasource: DATASOURCE_CONFIG.DATASOURCE,
          },
        ],
      };

      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetEntiryHistoryListThunk = createAsyncThunk(
  "common/GetEntiryHistoryListThunk",
  async (payload) => {
    const queryBody = {
      datasource: DATASOURCE_CONFIG.DATASOURCE,
      entity: payload?.entity,
      entity_id: payload?.entity_id,
      start_date: payload?.start_date,
      end_date: payload?.end_date,
      show_all_data: payload?.show_all_data,
    };

    try {
      const response = await axiosApiInstance.post(
        getEntityHistoryApiUrl,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

const { actions, reducer } = Common;
// Extract and export each action creator by name
export const {
  showHideSwitchAccountModal,
  switchToAccount,
  updateDashboardFilter,
  updateDashboardFilterDates,
  updateGlobalListFlag,
  showHideSwitchUserModal,
  updateAllGlobalList,
  updateAuthUserTheme,
  updateAuthUserLogo,
  showHideUserTimezoneModal,
  updateUserTimezone,
  updateAuthUserTimeZone,
  updateAuthUserLogoHeight
} = actions;
// Export the reducer, either as a default or named export
export default reducer;
